<template>
    <div class="lm-select-store">
        <lm-dialog v-model:visible="data.visible" title="快速切换门店" logOut modal width="1180" confirmTxt="确认选择" :beforeCancel="beforeCancel" :beforeConfirm="beforeConfirm" @confirm="onConfirm">
            <div class="form-table">
                <el-form :inline="true" :model="form.state" class="demo-form-inline" @submit.prevent="search">
                    <el-form-item label="组织筛选">
                        <el-select v-model="form.state.companyCode" placeholder="选择分公司" class="width-128" clearable filterable @change="onSelectCompany">
                            <el-option v-for="(item, index) in data.companyList" :key="index" :label="item.code + '-' + item.name" :value="item.code" />
                        </el-select>
                        <el-select v-model="form.state.deliverCode" placeholder="选择配送中心" class="width-158" clearable filterable>
                            <el-option v-for="(item, index) in data.deliverList" :key="index" :label="item.code + '-' + item.name" :value="item.code" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="终端名">
                        <el-input v-model="form.state.storeName" placeholder="输入终端名" clearable class="width-158" @keyup.enter="search" />
                    </el-form-item>
                    <el-form-item label="终端编码">
                        <el-input v-model="form.state.storeCode" placeholder="输入终端编码" clearable class="width-128" @keyup.enter="search" />
                    </el-form-item>
                    <el-form-item label="">
                        <lm-button :icon="Search" round label="搜索" width="80" height="32" @click="search" />
                    </el-form-item>
                    <el-checkbox v-model="form.state.bind" :true-value="1" :false-value="0" v-if="userStore.userInfo?.adminIdentity == 2" @change="changeCheckbox">
                        关注店铺
                    </el-checkbox>
                </el-form>

                <el-table ref="singleTableRef" :data="tableData.list" highlight-current-row style="width: 100%" @current-change="handleCurrentChange" height="50vh">
                    <el-table-column type="index" label="选择" width="80" align="center">
                        <template #default="{ row }">
                            <el-radio-group v-model="data.storeId" class="activities">
                                <el-radio :value="row.store_id" />
                            </el-radio-group>
                        </template>
                    </el-table-column>
                    <el-table-column property="shop" label="终端" width="140" />
                    <el-table-column property="name" label="分公司" width="120">
                        <template #default="{ row }">
                            <div>
                                {{ row.company_code }}-{{ row.company_name }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column property="deliver" label="配送中心" />
                    <el-table-column property="name" label="联系人" />
                    <el-table-column property="mobile" label="联系电话" />
                    <el-table-column property="address" label="地址信息" />
                    <el-table-column label="即时零售" width="135" align="left">
                        <template #default="{ row }">
                            <div class="retail-platforms-cell">
                                <span
                                    class="platform-badge"
                                    :class="{ 'badge-inactive': !row.appPoiCode }"
                                    :title="`美团：${row.appPoiCode ? '已入驻' : '未入驻'}`"
                                >
                                    <img class="platform-icon" :src="iconMeituan" alt="美团">
                                </span>
                                <span
                                    class="platform-badge"
                                    :class="{ 'badge-inactive': !row.eleShopCode }"
                                    :title="`淘闪购：${row.eleShopCode ? '已入驻' : '未入驻'}`"
                                >
                                    <img class="platform-icon" :src="iconEle" alt="淘闪购">
                                </span>
                                <span
                                    class="platform-badge"
                                    :class="{ 'badge-inactive': !row.jdShopCode }"
                                    :title="`京东：${row.jdShopCode ? '已入驻' : '未入驻'}`"
                                >
                                    <img class="platform-icon" :src="iconJd" alt="京东">
                                </span>
                                <span
                                    class="platform-badge"
                                    :class="{ 'badge-inactive': !row.miniProgramStoreCode }"
                                    :title="`自营小程序：${row.miniProgramStoreCode ? '已入驻' : '未入驻'}`"
                                >
                                    <img class="platform-icon" :src="iconXcx" alt="自营小程序">
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div>
                    <lm-pagination :pageIndex="data.pageIndex" :pageSize="data.pageSize" :sizeRange="[10, 20, 50, 100]" :total="tableData.total" :fetch="fetchTableData" />
                </div>
            </div>
        </lm-dialog>
    </div>
</template>

<script lang="ts" setup>
import LmDialog from "@/components/lm-dialog/index.vue";
import LmButton from "@/components/lm-button/index.vue";
import LmPagination from "../lm-pagination/index.vue";
import { Search } from "@element-plus/icons-vue";
import { useUserStore } from "@/stores/modules/user";
import { useAdminPermissionStore } from "@/stores/modules/admin/permission";
import { getCompanyList, getDeliverList, shopList, shopSelect } from "@/network/NetworkUser";
import iconMeituan from "@/assets/icon/mt.png";
import iconEle from "@/assets/icon/ele.png";
import iconJd from "@/assets/icon/jd.png";
import iconXcx from "@/assets/icon/xcx.png";
const message = useMessage();
const router = useRouter();
const userStore = useUserStore();
const permissionStore = useAdminPermissionStore();
const data = reactive({
    visible: false,
    storeId: 0,
    companyList: [] as any,
    deliverList: [] as any,
    pageIndex: 1,
    pageSize: 10
});

const tableData = reactive({
    list: [],
    total: 0
});

const form = reactive({
    state: {
        companyCode: "",
        deliverCode: "",
        storeName: "",
        storeCode: ""
    } as any
});

// const

const openDialog = async () => {
    data.visible = true;
    data.storeId = userStore.userInfo?.shop_selected?.store_id;
    if (userStore.userInfo?.adminIdentity == 2) {
        form.state.bind = 1;
        form.state.code = "";
    }
    getShopList();
    factchCompanyList();
};

const changeCheckbox = (val: any) => {
    if (val == 1) {
        form.state.bind = 1;
        form.state.code = "";
    } else {
        form.state.bind = -1;
        form.state.code = -2;
    }
};

const factchCompanyList = async () => {
    const res = await getCompanyList();
    data.companyList = res.data.list;
};

const onSelectCompany = async (val: any) => {
    data.deliverList = [];
    form.state.deliverCode = "";
    const res = await getDeliverList({ companyCode: val });
    data.deliverList = res.data.list;
};

const search = () => {
    data.pageIndex = 1;
    getShopList();
};

const getShopList = async () => {
    const res = await shopList({ ...form.state, pageNo: data.pageIndex, pageSize: data.pageSize });
    tableData.list = res.data.items;
    tableData.total = res.data.total;
};

const handleCurrentChange = (val: any) => {
    if (val && val.store_id) {
        data.storeId = val.store_id;
    }
};

const beforeCancel = async () => {
    if (!userStore.userInfo?.has_shop_selected) {
        message.notifyError("请选择终端店");
        return false;
    }
    return true;
};

const beforeConfirm = async () => {
    if (data.storeId) {
        return true;
    } else {
        message.notifyError("请选择终端店");
        return false;
    }
};

const onConfirm = async () => {
    try {
        await shopSelect({ shop_id: data.storeId });
        localStorage.setItem("storeId", String(data.storeId));
        await userStore.getUserMe();

        const currentPath = router.currentRoute.value.path;
        const isAdmin = currentPath.startsWith("/pcadmin");

        if (isAdmin) {
            // 在管理后台环境：主动刷新后台权限、菜单树及路由
            await permissionStore.handleStoreChange({
                targetStoreId: data.storeId,
                source: "header"
            });
        } else {
            // 在商城前台环境：重置后台权限路由状态（确保后续进入后台时以新门店身份重新拉取），并刷新当前前台页面
            permissionStore.resetRoutes();
            nextTick(() => {
                router.replace({ path: "/refresh" });
            });
        }
    } catch (err: any) {
        console.error("[lm-select-store] onConfirm error:", err);
        message.notifyError(err?.message || "切换门店失败，请重试");
    }
};

function fetchTableData({ pageIndex, pageSize }: { pageIndex: number; pageSize: number }) {
    console.log(pageIndex, pageSize);
    data.pageIndex = pageIndex;
    data.pageSize = pageSize;
    getShopList();
}

defineExpose({
    openDialog
});
</script>

<style lang="scss" scoped>
    .demo-form-inline {
        margin: 20px 0;
    }
    .width-158 {
        margin-left: 10px;
        width: 158px;
    }
    .width-128 {
        width: 128px;
    }
    :deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
        color: $primary;
    }

    :deep(.template-dialog) {
        position: fixed !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
        margin-top: 0 !important;
    }

    .retail-platforms-cell {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 5px;

        .platform-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 22px;
            height: 22px;
            border-radius: 4px;
            overflow: hidden;
            flex-shrink: 0;
            user-select: none;

            .platform-icon {
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
            }

            &.badge-inactive .platform-icon {
                filter: grayscale(1);
                opacity: 0.5;
            }
        }
    }
</style>
